export var DEFAULT_LOCALE_TEXT = {
    loadingOoo: 'Loading...',
    blanks: '(Blanks)',
    searchOoo: 'Search...',
    selectAll: '(Select All)',
    selectAllSearchResults: '(Select All Search Results)',
    noMatches: 'No matches.'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ag-grid-enterprise/set-filter/dist/es6/setFilter/localeText.js
// module id = 1230
// module chunks = 0